import axios from "axios";
import {
  AUTH_CHECK_ERROR,
  AUTH_CHECK_LOADING,
  AUTH_CHECK_SUCCESS,
  AUTH_LOGIN_ERROR,
  AUTH_LOGIN_LOADING,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT,
  AUTH_SIGNUP_ERROR,
  AUTH_SIGNUP_LOADING,
  AUTH_SIGNUP_SUCCESS,
} from "./auth.types";

const handleUser = (payload) => ({
  type: AUTH_LOGIN_SUCCESS,
  payload,
});

export const loginSuccess = (creds) => async (dispatch) => {
  dispatch({ type: AUTH_LOGIN_LOADING });
  try {
    await axios
      .post("https://truerent.onrender.com/user/login", creds)
      .then((data) => {
        console.log(data);
        if (data.data.error) {
          dispatch({ type: AUTH_LOGIN_ERROR, payload: data.data.error });
        } else {
          dispatch({ type: AUTH_LOGIN_SUCCESS, payload: data.data });
        }
        return data;
      });
  } catch (e) {
    dispatch({ type: AUTH_LOGIN_ERROR });
  }
};

export const signupSuccess = (creds) => async (dispatch) => {
  dispatch({ type: AUTH_SIGNUP_LOADING });
  try {
    await axios
      .post("https://truerent.onrender.com/user/signup", creds)
      .then((data) => {
        console.log(data);
        if (data.data.error) {
          dispatch({ type: AUTH_SIGNUP_ERROR, payload: data.data.error });
        } else {
          dispatch({ type: AUTH_SIGNUP_SUCCESS, payload: data.data });
        }
        return data;
      });
  } catch (e) {
    dispatch({ type: AUTH_SIGNUP_ERROR, payload: "Server Error" });
  }
};

export const checkEmail = (email) => async (dispatch) => {
  dispatch({ type: AUTH_CHECK_LOADING });
  try {
    await axios
      .post("https://truerent.onrender.com/user/", { email })
      .then((data) => {
        console.log(data);
        if (data.data.error) {
          dispatch({ type: AUTH_CHECK_ERROR, payload: "Server Error" });
        } else {
          dispatch({ type: AUTH_CHECK_SUCCESS, payload: data.data });
        }
        return data;
      });
  } catch (e) {
    dispatch({ type: AUTH_SIGNUP_ERROR, payload: "Server Error" });
  }
};

export const login = (creds) => (dispatch) => {
  dispatch(handleUser(creds));
};

const handleLogout = () => ({
  type: AUTH_LOGOUT,
});

export const logoutSuccess = () => (dispatch) => {
  dispatch({ type: AUTH_LOGOUT });
};
